import React from 'react';
import { connect } from 'react-redux';
import { getTimezone } from '../../selectors/common';
import { getDateTime } from '../../utils/common';

const mapToProps = (state) => ({
  getTimezone: getTimezone(state),
});
const PlayersTemplateRows = (props) => (
  props.playerTemplateList && props.playerTemplateList?.length > 0 ? (
    props.playerTemplateList?.map((player) => (
      <tr key={player.id}>
        <td>{player.id}</td>
        <td>{player.filename}</td>
        <td>{props.leagues.find((league) => league.id === player.competitionId)?.name }</td>
        <td>
          {player.isActive
            ? <span className="icon-check" />
            : '-'}
        </td>
        <td>{getDateTime(player.startDate, props.getTimezone)}</td>
        <td>{getDateTime(player.endDate, props.getTimezone) || '-'}</td>
      </tr>
    )))
    : (
      <tr><td>no result</td></tr>
    ));

export default connect(mapToProps)(PlayersTemplateRows);
